export default __webpack_public_path__ + "static/media/instalarAndroid.1f423d0d.png";